import {
  Component,
  OnInit,
  AfterViewInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router } from "@angular/router";
import { AppsService } from "src/app/shared/services/apps.service";
import * as L from "leaflet";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import moment from "moment";

@Component({
  selector: "app-driver-dashboard",
  templateUrl: "./driver-dashboard.component.html",
  styleUrls: ["./driver-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DriverDashboardComponent implements OnInit, AfterViewInit {
  header_label = {
    name: "Driver Dashboard",
  };

  showLdr = false;
  filters: boolean = true;
  drvrDtls: any = [];
  shwdtlsErrMsg;
  drvrTtlDtls: any;
  init_lat = 17;
  init_lng = 81;
  shwLastweekErrMsg;
  today = new Date();
  curYr: any;
  crw_nm;
  crw_lcnse_nu;
  crw_doj;
  crw_ph;
  crw_asgndVeh;
  crw_vehSchvlm;
  crw_vehSts;
  drvrOptnlDtls;
  drvrFulDtls: any;
  drvrSpdDtls: any;
  ovrSpeedMsg: string;
  oprtnlhrsMsg: string;
  oprtnlhrs;
  fuelDtaMsg: string;
  drvrHrlyMsg: string;
  gtDta;
  // Attendance data
  attendanceData: any = {
    daysPresent: 0,
    totalDays: 7,
    percentage: 0,
    streak: 0,
    lastActive: "N/A",
  };
  attendanceDays: any[] = [];
  tntLst: any = [];
  clntDtls: any;
  selectedtenant = 0;
  vendorList: any = [];
  selectedvndr = 0;
  selectedrvr;
  drvrslst: any;
  drvrnm: any;
  postData: {};
  userDtls: any;
  clap_in: number;
  ShowClap: boolean;
  showVndr: boolean;
  nodata: boolean;
  drvrHrlyDtls: any;
  noHourlyData: boolean = false;
  shwChrt: boolean;
  crwDtls;
  driverMap: any;
  driverMapMarker: any;
  hepachart: any;
  lastSevenDaysDistanceChart: any;
  lastSevenDaysChart: any;
  fromUrbanDashboard: boolean = false;

  constructor(public apiServ: AppsService, private router: Router) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    // this.selectedtenant = this.tntLst[0].tnt_id;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    console.log(this.userDtls);
    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    }
  }

  goBackToDashboard() {
    this.router.navigate([`internal/dashboard/urban-dashboard`]);
  }

  ngOnInit() {
    this.fromUrbanDashboard =
      JSON.parse(localStorage.getItem("from_urban_dashboard")) === true;
    localStorage.setItem("from_urban_dashboard", JSON.stringify(false));
    this.curYr = moment(this.today).format("YYYY");
    console.log("In ----------------------------------- DAte", this.curYr);
    this.getDriversLst();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialize();
      if (this.driverMap) {
        this.driverMap.invalidateSize();
      }
    }, 300);
  }

  initialize = function () {
    //----------Map Initialization (Google Streets Layer) -- Leaflet OS Playback----------//
    try {
      this.driverMap = L.map("driverMap", {
        center: [this.init_lat, this.init_lng],
        zoom: 14,
      });

      // Use Google Streets layer
      const tiles = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 18,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution: "",
        }
      );

      tiles.addTo(this.driverMap);
    } catch (e) {
      // console.log("please check map Initialization of leaflet:" + e);
    }
  };
  getDriverdetails(drvrId): any {
    this.drvrDtls = [];
    this.showLdr = true;
    this.crw_nm = "";
    this.crw_lcnse_nu = "";
    this.crw_doj = "";
    this.crw_ph = "";
    this.crw_asgndVeh;
    this.crw_vehSchvlm;
    this.crw_vehSts;
    this.crwDtls = [];
    const rte = `drivers/getEachDriverDetails/${drvrId}`;
    this.apiServ.get(rte).subscribe(
      (res) => {
        if (res["data"] && res["data"].length >= 0) {
          this.drvrDtls = res["data"];
          console.log(this.drvrDtls[0]);
          this.crwDtls = this.drvrDtls[0];

          // Clear existing marker
          if (this.driverMapMarker) {
            this.driverMap.removeLayer(this.driverMapMarker);
          }

          // Add map marker if location available
          if (
            this.drvrDtls[0] &&
            this.drvrDtls[0].lat &&
            this.drvrDtls[0].lng
          ) {
            let icon = "_o_m.png";
            if (this.drvrDtls[0].asrtglblId == "1") {
              if (this.drvrDtls[0].spd_ct <= "5") {
                icon = "_p_m.png";
              } else {
                icon = "_r_m.png";
              }
            }

            const vehIcon = new L.Icon({
              iconUrl: `assets/images/markers/mapIcons/m/${this.drvrDtls[0].icon_path}${icon}`,
              iconSize: [30, 30],
              iconAnchor: [15, 15],
              popupAnchor: [0, -15],
              shadowSize: [35, 35],
            });

            this.driverMapMarker = L.marker(
              [this.drvrDtls[0].lat, this.drvrDtls[0].lng],
              {
                icon: vehIcon,
              }
            ).addTo(this.driverMap);
            this.driverMap.setView(
              [this.drvrDtls[0].lat, this.drvrDtls[0].lng],
              13
            );

            const coords = L.latLng([
              this.drvrDtls[0].lat,
              this.drvrDtls[0].lng,
            ]);
            L.popup()
              .setLatLng(coords)
              .setContent(this.drvrDtls[0].asrt_nm)
              .openOn(this.driverMap);
          }

          this.showLdr = false;
        } else {
          this.showLdr = false;
          this.crw_nm =
            this.gtDta && this.gtDta.driver
              ? this.gtDta.driver.currentValue.crw_nm
              : "";
          this.crw_lcnse_nu =
            this.gtDta && this.gtDta.driver
              ? this.gtDta.driver.currentValue.crw_lcnse_nu
              : "";
          this.crw_doj =
            this.gtDta && this.gtDta.driver
              ? this.gtDta.driver.currentValue.doj
              : "";
          this.crw_ph =
            this.gtDta && this.gtDta.driver
              ? this.gtDta.driver.currentValue.crw_ph
              : "";
          this.shwdtlsErrMsg =
            "No details found regarding to the selected Driver";
        }
      },
      (err) => {
        console.log(err);
        this.showLdr = false;
      }
    );
  }
  getTotalDtls(drvrId, tntId, vndrId): any {
    this.drvrTtlDtls = [];
    this.showLdr = true;
    this.postData = {
      selectedrvr: drvrId,
      selectedtenant: tntId,
      selectedvndr: vndrId,
    };
    console.log(this.postData);
    const rte = `drivers/getTotalCnts`;
    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.drvrTtlDtls = res["data"];
        console.log(this.drvrTtlDtls);
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getDriverhourlyDtls(drvrId, tntId, vndrId): any {
    this.drvrHrlyDtls = [];
    this.showLdr = true;
    this.postData = {
      selectedrvr: drvrId,
      selectedtenant: tntId,
      selectedvndr: vndrId,
    };
    const rte = `drivers/driver/hourly_distance`;

    // Dispose existing chart if any
    if (this.hepachart) {
      this.hepachart.dispose();
    }

    let chart = am4core.create("hepachartdiv", am4charts.XYChart);
    this.hepachart = chart;
    chart.data = [];

    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.drvrHrlyDtls = res["data"] || [];
        this.drvrHrlyDtls.forEach((obj) => {
          if (obj.dst == null) {
            obj.dst = 0;
          } else {
            obj.dst = obj.dst;
          }
        });
        this.noHourlyData =
          this.drvrHrlyDtls.length === 0 ||
          this.drvrHrlyDtls.every((o: any) => !o.dst || Number(o.dst) === 0);
        console.log(this.drvrHrlyDtls);
        chart.data = this.drvrHrlyDtls;

        chart.maskBullets = true;

        // X-Axis (Hours)
        var xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        xAxis.dataFields.category = "trvl_hr";
        xAxis.renderer.grid.template.disabled = true;
        xAxis.renderer.minGridDistance = 30;
        xAxis.renderer.labels.template.fontSize = 12;
        xAxis.renderer.labels.template.fontWeight = "600";
        xAxis.renderer.labels.template.fill = am4core.color("#4b5563");
        xAxis.title.text = "Hours";
        xAxis.title.fontSize = 12;
        xAxis.title.fontWeight = "600";
        xAxis.title.fill = am4core.color("#6b7280");

        // Y-Axis (Dates)
        var yAxis = chart.yAxes.push(new am4charts.CategoryAxis());
        yAxis.dataFields.category = "trvl_dt";
        yAxis.renderer.grid.template.disabled = true;
        yAxis.renderer.inversed = true;
        yAxis.renderer.minGridDistance = 25;
        yAxis.renderer.labels.template.fontSize = 12;
        yAxis.renderer.labels.template.fontWeight = "600";
        yAxis.renderer.labels.template.fill = am4core.color("#4b5563");
        yAxis.title.text = "Date";
        yAxis.title.fontSize = 12;
        yAxis.title.fontWeight = "600";
        yAxis.title.fill = am4core.color("#6b7280");

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "trvl_hr";
        series.dataFields.categoryY = "trvl_dt";
        series.dataFields.value = "dst";
        series.sequencedInterpolation = true;
        series.defaultState.transitionDuration = 3000;

        var bgColor = new am4core.InterfaceColorSet().getFor("background");

        var columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 1;
        columnTemplate.strokeOpacity = 0.2;
        columnTemplate.stroke = bgColor;
        columnTemplate.tooltipText =
          "Date: {categoryY}\nHour: {categoryX}\nDistance: {dst} km";
        columnTemplate.width = am4core.percent(100);
        columnTemplate.height = am4core.percent(100);

        series.heatRules.push({
          target: columnTemplate,
          property: "fill",
          min: am4core.color("#e0e7ff"),
          max: am4core.color("#4f46e5"),
        });

        var legend = new am4charts.Legend();
        legend.parent = chart.chartContainer;
        legend.data = [
          {
            name: "Distance Covered (km)",
            fill: am4core.color("#4f46e5"),
          },
        ];

        // heat legend
        var heatLegend = chart.bottomAxesContainer.createChild(
          am4charts.HeatLegend
        );
        heatLegend.width = am4core.percent(100);
        heatLegend.series = series;
        heatLegend.valueAxis.renderer.labels.template.fontSize = 11;
        heatLegend.valueAxis.renderer.labels.template.fill =
          am4core.color("#6b7280");
        heatLegend.valueAxis.renderer.minGridDistance = 30;

        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{dst}";
        valueLabel.label.fontSize = 11;
        valueLabel.label.fill = am4core.color("#1f2937");
        valueLabel.label.fontWeight = "500";

        columnTemplate.column.cornerRadiusTopLeft = 4;
        columnTemplate.column.cornerRadiusTopRight = 4;
        columnTemplate.column.cornerRadiusBottomLeft = 4;
        columnTemplate.column.cornerRadiusBottomRight = 4;

        // heat legend behavior
        series.columns.template.events.on("over", function (event) {
          handleHover(event.target);
        });

        series.columns.template.events.on("hit", function (event) {
          handleHover(event.target);
        });

        function handleHover(column) {
          if (!isNaN(column.dataItem.value)) {
            heatLegend.valueAxis.showTooltipAt(column.dataItem.value);
          } else {
            heatLegend.valueAxis.hideTooltip();
          }
        }

        series.columns.template.events.on("out", function (event) {
          heatLegend.valueAxis.hideTooltip();
        });

        if (this.drvrHrlyDtls.length == 0) {
          this.drvrHrlyMsg = "Hourly Distance not found to this driver.";
        } else {
          this.drvrHrlyMsg = "";
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  chrtVsblcnt = 0;

  getLst7Daysdtls(drvrId, tntId, vndrId): any {
    this.showLdr = true;

    // Dispose existing charts if any
    if (this.lastSevenDaysDistanceChart) {
      this.lastSevenDaysDistanceChart.dispose();
    }
    if (this.lastSevenDaysChart) {
      this.lastSevenDaysChart.dispose();
    }

    let chart1 = am4core.create(
      "lastSevenDaysDistanceChart",
      am4charts.XYChart
    );
    let chart2 = am4core.create("lastSevenDaysChart", am4charts.XYChart);
    this.lastSevenDaysDistanceChart = chart1;
    this.lastSevenDaysChart = chart2;
    chart1.data = [];
    chart2.data = [];
    this.postData = {
      selectedrvr: drvrId,
      selectedtenant: tntId,
      selectedvndr: vndrId,
    };
    const rte = `drivers/getLast7DaysCnts`;
    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.drvrDtls = res["data"].results;
        console.log(this.drvrDtls);
        chart1.data = this.drvrDtls;
        chart2.data = this.drvrDtls;
        // chart2.legend = new am4charts.Legend();
        // if(this.drvrDtls[0].trp_ct!=0 || this.drvrDtls[1].trp_ct!=0  || this.drvrDtls[2].trp_ct!=0 ||
        //   this.drvrDtls[3].trp_ct!=0 || this.drvrDtls[4].trp_ct!=0 || this.drvrDtls[5].trp_ct!=0 || this.drvrDtls[6].trp_ct!=0 ){
        //     this.nodata=true;
        //   }else{
        //     this.nodata=false;
        //   }00000
        if (res["data"].msg == 0) {
          this.nodata = true;
        } else {
          this.nodata = false;
        }
        console.log(this.nodata);
        this.showLdr = false;
        this.shwLastweekErrMsg = "";

        let categoryAxis = chart2.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "app_dt";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.title.text = ` ----- Date(${this.curYr}) ----- `;
        let valueAxis = chart2.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = " ----- Trips Covered -----";
        valueAxis.cursorTooltipEnabled = false;
        let series = chart2.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = "trvl_trp_cnt";
        series.dataFields.categoryX = "app_dt";
        series.clustered = false;
        series.columns.template.width = am4core.percent(50);
        series.tooltipText =
          "Travelled Trips on {categoryX}: [bold]{valueY}[/]";
        series.columns.template.fill = am4core.color("#55ac73");
        series.columns.template.stroke = am4core.color("#55ac73");
        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{trvl_trp_cnt}";
        valueLabel.label.fontSize = 15;
        let columnTemplate = series.columns.template;
        columnTemplate.strokeWidth = 1;
        chart2.cursor = new am4charts.XYCursor();
        chart2.cursor.lineX.disabled = true;
        chart2.cursor.lineY.disabled = true;

        let categoryAxis1 = chart1.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis1.dataFields.category = "app_dt";
        categoryAxis1.renderer.grid.template.location = 0;
        categoryAxis1.renderer.minGridDistance = 30;
        categoryAxis1.title.text = ` ----- Date(${this.curYr}) ----- `;
        let valueAxis1 = chart1.yAxes.push(new am4charts.ValueAxis());
        valueAxis1.title.text = " ----- Distance Covered -----";
        valueAxis1.cursorTooltipEnabled = false;
        let series2 = chart1.series.push(new am4charts.ColumnSeries());
        series2.dataFields.valueY = "tot_dst";
        series2.dataFields.categoryX = "app_dt";
        series2.clustered = false;
        series2.columns.template.width = am4core.percent(50);
        series2.tooltipText =
          "Travelled Distance on {categoryX}: [bold]{valueY}[/]KM";
        series2.columns.template.fill = am4core.color("#544aba");
        series2.columns.template.stroke = am4core.color("#544aba");
        let valueLabel2 = series2.bullets.push(new am4charts.LabelBullet());
        valueLabel2.label.text = "{tot_dst}";
        valueLabel2.label.fontSize = 15;
        let columnTemplate2 = series2.columns.template;
        columnTemplate2.strokeWidth = 1;
        chart1.cursor = new am4charts.XYCursor();
        chart1.cursor.lineX.disabled = true;
        chart1.cursor.lineY.disabled = true;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getOprtnlDtls(drvrId, tntId, vndrId): any {
    this.drvrOptnlDtls = [];
    this.attendanceDays = [];
    // Reset attendance data immediately when switching drivers
    this.attendanceData = {
      daysPresent: 0,
      totalDays: 7,
      percentage: 0,
      streak: 0,
      lastActive: "N/A",
    };
    this.showLdr = true;
    this.postData = {
      selectedrvr: drvrId,
      selectedtenant: tntId,
      selectedvndr: vndrId,
    };
    const rte = `drivers/operational`;
    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.drvrOptnlDtls = res["data"];
        console.log(this.drvrOptnlDtls);
        if (this.drvrOptnlDtls.length == 0) {
          this.oprtnlhrsMsg = "No Operational Details found to this driver.";
          // Generate 7 days of absent data so attendance cards always display
          this.drvrOptnlDtls = [];
          for (let i = 6; i >= 0; i--) {
            this.drvrOptnlDtls.push({
              dt: moment().subtract(i, "days").format("YYYY-MM-DD"),
              operated: 0,
              asrt_nm: "-",
              asrt_ctgry_nm: "-",
              oprtn_hrs_ct: 0,
              dst: 0,
            });
          }
          this.calculateAttendance();
        } else {
          this.oprtnlhrsMsg = "";
          this.calculateAttendance();
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  // getFuelDtls(drvrId): any {
  //   this.drvrFulDtls = [];
  //   this.showLdr = true;
  //   const rte = `drivers/fuel/${drvrId}`;
  //   this.apiServ.get(rte).subscribe((res) => {
  //         this.drvrFulDtls = res['data'];
  //         console.log(this.drvrFulDtls);
  //         if(this.drvrFulDtls.length == 0){
  //           this.fuelDtaMsg = 'Fuel Issued not found to this driver.';
  //         }else{
  //           this.fuelDtaMsg = '';
  //         }
  //         this.showLdr = false;
  //   }, (err) => {
  //     console.log(err);
  //   });
  // }

  getSpeedDtls(drvrId, tntId, vndrId): any {
    this.drvrSpdDtls = [];
    this.showLdr = true;
    this.postData = {
      selectedrvr: drvrId,
      selectedtenant: tntId,
      selectedvndr: vndrId,
    };
    const rte = `drivers/overspeed`;
    this.apiServ.post(this.postData, rte).subscribe(
      (res) => {
        this.drvrSpdDtls = res["data"];
        console.log(this.drvrSpdDtls);
        if (this.drvrSpdDtls.length == 0) {
          this.fuelDtaMsg = "Speed Violation not found to this driver.";
        } else {
          this.fuelDtaMsg = "";
        }
        this.showLdr = false;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getVendors() {
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      this.apiServ
        .get(`billing/vendors/list/${this.selectedvndr}/byId`)
        .subscribe(
          (res) => {
            console.log(res);
            if (res["status"] == 200) {
              this.vendorList = res["data"];
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
    } else {
      this.apiServ
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              // this.USER_PERMISSIONS = res['perm'][0];
              if (this.vendorList.length > 1) {
                this.selectedvndr = 0;
              } else {
                this.selectedvndr = this.vendorList[0].vndr_id;
              }
            }
          },
          (err) => {
            console.log("In errorr");
          }
        );
    }
  }

  getDriversLst = (drvr?) => {
    const fltrData = {
      selectedtenant: this.selectedtenant,
    };
    this.selectedrvr = drvr;
    console.log("this.selectedrvr", this.selectedrvr);
    if (this.selectedvndr) {
      // tslint:disable-next-line:no-string-literal
      fltrData["selectedvndr"] = this.selectedvndr;
    }
    this.showLdr = true;
    this.apiServ.post(fltrData, "drivers/drivers").subscribe(
      (res) => {
        this.drvrslst = res["data"];
        this.showLdr = false;
        console.log(this.drvrslst);

        if (this.selectedrvr) {
          console.log("in", this.selectedrvr);
          this.getDriverdetails(this.selectedrvr);
          this.getTotalDtls(
            this.selectedrvr,
            this.selectedtenant,
            this.selectedvndr
          );
          this.getLst7Daysdtls(
            this.selectedrvr,
            this.selectedtenant,
            this.selectedvndr
          );
          this.getOprtnlDtls(
            this.selectedrvr,
            this.selectedtenant,
            this.selectedvndr
          );
          // this.getFuelDtls(this.selectedrvr);
          this.getSpeedDtls(
            this.selectedrvr,
            this.selectedtenant,
            this.selectedvndr
          );
          setTimeout(() => {
            this.getDriverhourlyDtls(
              this.selectedrvr,
              this.selectedtenant,
              this.selectedvndr
            );
          }, 100);

          // for(let i=0; i<this.drvrslst.length; i++){
          //   if(this.drvrslst[i].crw_id == this.selectedrvr){
          //     this.crw_nm = this.drvrslst[i].crw_nm;
          //     this.crw_lcnse_nu = this.drvrslst[i].crw_lcnse_nu;
          //     this.crw_doj = this.drvrslst[i].doj;
          //     this.crw_ph = this.drvrslst[i].crw_ph;
          //   }
          // }
        } else {
          console.log("else");
          this.selectedrvr = this.drvrslst[0].crw_id;

          this.getDriverdetails(this.drvrslst[0].crw_id);
          this.getTotalDtls(
            this.drvrslst[0].crw_id,
            this.drvrslst[0].tnt_id,
            this.drvrslst[0].vndr_id
          );
          this.getLst7Daysdtls(
            this.drvrslst[0].crw_id,
            this.drvrslst[0].tnt_id,
            this.drvrslst[0].vndr_id
          );
          this.getOprtnlDtls(
            this.drvrslst[0].crw_id,
            this.drvrslst[0].tnt_id,
            this.drvrslst[0].vndr_id
          );
          // this.getFuelDtls(this.drvrslst[0].crw_id);
          this.getSpeedDtls(
            this.drvrslst[0].crw_id,
            this.drvrslst[0].tnt_id,
            this.drvrslst[0].vndr_id
          );
          setTimeout(() => {
            this.getDriverhourlyDtls(
              this.drvrslst[0].crw_id,
              this.drvrslst[0].tnt_id,
              this.drvrslst[0].vndr_id
            );
          }, 100);

          // this.crw_nm = this.drvrslst[0].crw_nm;
          // this.crw_lcnse_nu = this.drvrslst[0].crw_lcnse_nu;
          // this.crw_doj = this.drvrslst[0].doj;
          // this.crw_ph = this.drvrslst[0].crw_ph;
        }

        //  this.drvrnm = this.drvrslst[0].crw_nm

        // this.drvrslst.forEach((element,index) => {
        //   element['clr_obj'] = this.colors[(index%this.colors.length)];
        // });
        // this.drvrslst.filter((k) => {
        //   k.chk_ind = true;
        // })

        // this.drvrslstcolumnDefs = [
        //   // { headerName: 'S.No', field: 'sno', alignment: 'center', width: 60, filter: false },
        //   { headerName: 'Driver Name', alignment: 'left',  field: 'crw_nm' },
        //   { headerName: 'Licence No', alignment: 'center',  field: 'crw_lcnse_nu' },
        //   { headerName: 'DOJ',   alignment: 'center',field:'doj' },
        //   { headerName: 'Mobile No', field: 'crw_ph',  alignment: 'center' }
        // ]
      },
      (err) => {
        // console.log(err);
      }
    );
  };

  ontntSelect(value) {
    this.selectedtenant = value;
    this.selectedvndr = 0;
    this.getVendors();
    this.getDriversLst();
  }

  onvndrSelect(value) {
    this.selectedvndr = value;
    this.getDriversLst();
  }
  ondrvrSelect(value) {
    this.selectedrvr = value;
    console.log(this.selectedrvr);
    // Bind ULB value from the selected driver
    const selDrvr = this.drvrslst.find((d) => d.crw_id === value);
    if (selDrvr && selDrvr.tnt_id) {
      this.selectedtenant = selDrvr.tnt_id;
    }
    this.getDriverdetails(this.selectedrvr);
    this.getTotalDtls(this.selectedrvr, this.selectedtenant, this.selectedvndr);
    this.getLst7Daysdtls(
      this.selectedrvr,
      this.selectedtenant,
      this.selectedvndr
    );
    this.getOprtnlDtls(
      this.selectedrvr,
      this.selectedtenant,
      this.selectedvndr
    );
    // this.getFuelDtls(this.selectedrvr);
    this.getSpeedDtls(this.selectedrvr, this.selectedtenant, this.selectedvndr);
    this.getDriverhourlyDtls(
      this.selectedrvr,
      this.selectedtenant,
      this.selectedvndr
    );
  }

  calculateAttendance(): void {
    if (this.drvrOptnlDtls && this.drvrOptnlDtls.length > 0) {
      // Use only last 7 days for attendance display
      this.attendanceDays = this.drvrOptnlDtls.slice(-7);
      const daysPresent = this.attendanceDays.filter(
        (o: any) => o.operated === 1
      ).length;
      const totalDays = this.attendanceDays.length;
      const percentage =
        totalDays > 0 ? Math.round((daysPresent / totalDays) * 100) : 0;

      // Calculate current streak
      let streak = 0;
      for (let i = this.attendanceDays.length - 1; i >= 0; i--) {
        if (this.attendanceDays[i].operated === 1) {
          streak++;
        } else {
          break;
        }
      }

      // Find last active date
      const lastActiveDay = [...this.attendanceDays]
        .reverse()
        .find((o: any) => o.operated === 1);
      const lastActive = lastActiveDay ? lastActiveDay.dt : "N/A";

      this.attendanceData = {
        daysPresent,
        totalDays,
        percentage,
        streak,
        lastActive,
      };
    }
  }

  // Always show the last 7 calendar days (curdate - 6 ... curdate).
  // Index 0 corresponds to today (matches SQL ORDER BY s.dt DESC).
  getAttendanceDate(index: number): string {
    const date = moment().subtract(index, "days");
    return date.format("MMM DD");
  }

  fltrs() {
    this.filters = !this.filters;
  }
}
